import { useState, useEffect } from 'react';
import axios from 'axios';

const ServicesList = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data - replace with actual API call
    const mockServices = [
      {
        id: 1,
        title: "Cloud Solutions",
        description: "Scalable cloud infrastructure and migration services for seamless digital transformation.",
        icon: "fas fa-cloud",
      },
      {
        id: 2,
        title: "Data Analytics",
        description: "Transform raw data into actionable insights with our advanced analytics platform.",
        icon: "fas fa-chart-line",
      },
      {
        id: 3,
        title: "AI & Machine Learning",
        description: "Custom AI solutions that automate processes and enhance decision-making.",
        icon: "fas fa-robot",
      },
      {
        id: 4,
        title: "Cybersecurity",
        description: "Comprehensive security solutions to protect your digital assets and data.",
        icon: "fas fa-shield-alt",
      },
      {
        id: 5,
        title: "Digital Transformation",
        description: "End-to-end digital strategy and implementation for modern businesses.",
        icon: "fas fa-sync-alt",
      },
      {
        id: 6,
        title: "IT Consulting",
        description: "Expert guidance on technology strategy, architecture, and implementation.",
        icon: "fas fa-users-cog",
      },
    ];
    
    setServices(mockServices);
    setLoading(false);
    
    // Actual API call would be:
    // axios.get('http://localhost:8000/api/services/')
    //   .then(response => {
    //     setServices(response.data);
    //     setLoading(false);
    //   })
    //   .catch(error => {
    //     console.error('Error fetching services:', error);
    //     setLoading(false);
    //   });
  }, []);

  if (loading) {
    return (
      <section className="section-padding">
        <div className="container-custom text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
        </div>
      </section>
    );
  }

  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100">
              <div className="w-16 h-16 bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl flex items-center justify-center mb-6">
                <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
                  <span className="text-white text-lg font-bold">{service.title.charAt(0)}</span>
                </div>
              </div>
              <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <button className="text-primary-600 font-semibold hover:text-primary-700 flex items-center">
                Learn More
                <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesList;